import { IParamQueryJobDetail } from '../interface/jobs';
import { IParamQueryOrderDetail } from './../interface/order';
// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
  verifyCode: 'auth/verify-code',
  resendCode: 'auth/resend-code',
  forgotPassword: 'auth/forgot-password',
  createNewPassword: 'auth/new-password',
};

// User
export const urlApiUser = {
  getListUser: 'users',
  createUser: 'users/new',
  changePasswordUser: 'users/change-password',
  getDetailUser: (userId: string) => `users/${userId}`,
  deleteUser: (userId: string) => `users/${userId}`,
  updateUser: (userId: string) => `users/${userId}`,
  getProfile: 'users/profile',
};

// Client
export const urlApiClient = {
  getListClient: 'clients',
  createClient: 'clients/new',
  updateClient: (clientId: string) => `clients/${clientId}`,
  deleteClient: (clientId: string) => `clients/${clientId}`,
  getDetailClient: (clientId: string, type: string) => `clients/${clientId}/${type}`,
};

// Coupon
export const urlApiCoupon = {
  getListCoupon: 'coupons',
  createCoupon: 'coupons/new',
  getDetailCoupon: (couponId: string) => `coupons/${couponId}`,
  updateCoupon: (couponId: string) => `coupons/${couponId}`,
  deleteCoupon: (couponId: string) => `coupons/${couponId}`,
};

// Quote
export const urlApiQuote = {
  getListQuote: 'quotes',
  createQuote: 'quotes/new',
  getDetailQuote: (quoteId: string, type: string) => `quotes/${quoteId}/${type}`,
  deleteQuote: (quoteId: string) => `quotes/${quoteId}`,
  updateQuote: (quoteId: string) => `quotes/${quoteId}`,
  convertQuoteToOrder: (quoteId: string) => `quotes/${quoteId}/convert-to-order`,
  changeStatusQuote: (quoteId: string) => `quotes/${quoteId}/change-status`,
  cloneQuote: `quotes/clone`,
  sendMailQuote: (quoteId: string) => `quotes/${quoteId}/send-mail`,
};

// Global
export const urlApiGlobal = {
  getListGlobal: '/globals',
};

// Order
export const urlApiOrder = {
  getListOrder: 'orders',
  getListOrderEvent: 'orders/event',
  deleteOrder: (orderId: string) => `orders/${orderId}`,
  updateOrder: (orderId: string) => `orders/${orderId}`,
  convertOrderToJob: (orderId: string) => `orders/${orderId}/convert-to-job`,
  getOrderSplit: (orderId: string) => `orders/${orderId}/split`,
  getDetailOrder: (params: IParamQueryOrderDetail) => `orders/${params.orderId}/${params.type}`,
  splitOrder: (orderId: string) => `orders/${orderId}/split`,
  revertToQuote: (orderId: string) => `orders/${orderId}/revert-to-quote`,
  sendMailOrder: (orderId: string) => `orders/${orderId}/send-mail`,
  changeStatusOrder: (orderId: string) => `orders/${orderId}/change-status`,
};

// Inventory
export const urlApiInventory = {
  getListInventoryQuote: 'inventories',
  getListInventoryProduct: 'inventories/product',
  createInventory: 'inventories/new',
  importInventory: 'inventories/import',
  getListInventoryHistory: (inventoryId: string) => `inventories/${inventoryId}/history`,
  getDetailInventory: (inventoryId: string, type: string) => `inventories/${inventoryId}/${type}`,
  deleteInventory: (inventoryId: string) => `inventories/${inventoryId}`,
  updateInventory: (inventoryId: string) => `inventories/${inventoryId}`,
  exportInventory: 'inventories/export-data',
  cloneInventory: `inventories/clone`,
};

// Variant
export const urlApiVariant = {
  getListVariant: 'variants',
  deleteVariant: (variantId: string) => `variants/${variantId}`,
};

// Schedule
export const urlApiSchedule = {
  getListSchedule: 'schedules',
  changEventSchedule: 'schedules/change-event',
  exportSchedule: 'schedules/export-data',
  revertScheduleToJob: (scheduleId: string) => `schedules/${scheduleId}/revert-to-job`,
};

// Job
export const urlApiJob = {
  getListJob: 'jobs',
  createJob: 'jobs/new',
  getListJobKanban: 'jobs/kanban',
  changeStatusJob: (jobId: string) => `jobs/${jobId}/change-status`,
  getDetailJob: (params: IParamQueryJobDetail) => `jobs/${params?.jobId}/${params?.type}`,
  updateJob: (jobId: string) => `jobs/${jobId}`,
  getListJobItem: (jobId: string) => `jobs/${jobId}/item`,
  deleteJob: (jobId: string) => `jobs/${jobId}`,
  additionalExpense: (jobId: string) => `jobs/${jobId}/additional-expense`,
  convertJobToSchedule: (jobId: string) => `jobs/${jobId}/convert-to-schedule`,
};

// Checklist
export const urlApiChecklist = {
  getChecklist: 'checklists/templates',
  createChecklist: 'checklists/new',
  deleteChecklist: (checklistId: string) => `checklists/${checklistId}`,
  createChecklistItem: 'checklist-items/new',
  deleteChecklistItem: (checkId: string) => `checklist-items/${checkId}`,
};

// Incident
export const urlApiIncident = {
  createIncident: 'incidents/new',
  deleteIncident: (incidentId: string) => `incidents/${incidentId}`,
};

// Package
export const urlApiPackage = {
  getListPackage: 'packages',
  createPackage: 'packages/new',
  getDetailPackage: (packageId: string) => `packages/${packageId}`,
  deletePackage: (packageId: string) => `packages/${packageId}`,
  updatePackage: (packageId: string) => `packages/${packageId}`,
  getListItemOptionalPackage: (packageId: string) => `packages/${packageId}/optional`,
};

// Category
export const urlApiCategory = {
  getListCategory: 'categories',
  createCategory: 'categories/new',
  getDetailCategory: (categoryId: string) => `categories/${categoryId}`,
  deleteCategory: (categoryId: string) => `categories/${categoryId}`,
  updateCategory: (categoryId: string) => `categories/${categoryId}`,
};

// File
export const urlApiFile = {
  downloadFile: (fileId: string) => `file/download/${fileId}`,
  attachFile: 'file/attach-files',
};

// Activity
export const urlApiActivity = {
  getActivityList: 'activities',
  createCallHistory: 'activities/call-history',
};

// Master Data
export const urlApiMasterData = {
  getListMasterData: '/master-data',
  createMasterData: '/master-data/new',
  getDetailMasterData: (masterDataId: string) => `master-data/${masterDataId}`,
  updateMasterData: (masterDataId: string) => `master-data/${masterDataId}`,
  deleteMasterData: (masterDataId: string) => `master-data/${masterDataId}`,
};

// Truck
export const urlApiTruck = {
  getListTruck: 'trucks',
  createTruck: 'trucks/new',
  getDetailTruck: (truckId: string) => `trucks/${truckId}`,
  deleteTruck: (truckId: string) => `trucks/${truckId}`,
  updateTruck: (truckId: string) => `trucks/${truckId}`,
};

// Reports
export const urlApiReports = {
  getListOverbookingItemReport: 'reports/overbooking-item',
  getListSubRentalsReport: 'reports/sub-rental',
  getListClientIncomeReport: 'reports/client-income',
  getListRevenueReport: 'reports/revenue',
  getListGeographyRevenueReport: 'reports/geographic-revenue',
  getListQuoteRevenueReport: 'reports/quote-revenue',
  getListOrderRevenueReport: 'reports/order-revenue',
  getListCancellationReport: 'reports/cancellation',
  getListDeliveryPickupReport: 'reports/delivery-pickup',
  getListTaskCompletionReport: 'reports/task-completion',
  getListDiscountUsageReport: 'reports/discount-usage',
  getListFeatureUtilizationReport: 'reports/future-utilization',
  getListJobCostingReport: 'reports/job-costing',
  getListInventoryUsageReport: 'reports/inventory-usage',
  getListForemanTaskCompletionReport: 'reports/foreman-revenue-tracker',
  getListMarketingRevenueReport: 'reports/marketing-revenue',
  getListFinancialOrderReport: 'reports/financial-order',
  getListTransactionSummaryReport: 'reports/transaction-summary',
  exportDataReport: `reports/export-data`,
};

// Trailer
export const urlApiTrailer = {
  getListTrailer: 'trailers',
  createTrailer: 'trailers/new',
  getDetailTrailer: (trailerId: string) => `trailers/${trailerId}`,
  deleteTrailer: (trailerId: string) => `trailers/${trailerId}`,
  updateTrailer: (trailerId: string) => `trailers/${trailerId}`,
};

// Equipment
export const urlApiEquipment = {
  getListEquipment: 'equipments',
  createEquipment: 'equipments/new',
  getDetailEquipment: (equipmentId: string) => `equipments/${equipmentId}`,
  deleteEquipment: (equipmentId: string) => `equipments/${equipmentId}`,
  updateEquipment: (equipmentId: string) => `equipments/${equipmentId}`,
};

// Purchase Order
export const urlApiPurchaseOrder = {
  getListPurchaseOrder: 'purchase-orders',
  createPurchaseOrder: 'purchase-orders/new',
  getDetailPurchaseOrder: (purchaseOrderId: string) => `purchase-orders/${purchaseOrderId}`,
  deletePurchaseOrder: (purchaseOrderId: string) => `purchase-orders/${purchaseOrderId}`,
  updatePurchaseOrder: (purchaseOrderId: string) => `purchase-orders/${purchaseOrderId}`,
  changeStatusPurchaseOrder: (purchaseOrderId: string) => `purchase-orders/${purchaseOrderId}/change-status`,
};

// Appointment
export const urlApiAppointments = {
  createAppointment: 'appointments/new',
  detailAppointment: (appointmentId: string) => `appointments/${appointmentId}`,
  updateAppointment: (appointmentId: string) => `appointments/${appointmentId}`,
};

// Task
export const urlApiTask = {
  getListTask: 'tasks',
  createTask: 'tasks/new',
  detailTask: (taskId: string) => `tasks/${taskId}`,
  updateTask: (taskId: string) => `tasks/${taskId}`,
  deleteTask: (taskId: string) => `tasks/${taskId}`,
};

// Vendor
export const urlApiVendors = {
  getListVendors: 'vendors',
  createVendors: 'vendors/new',
  editVendors: (vendorId: string) => `vendors/${vendorId}`,
  getDetailVendors: (vendorId: string, type: string) => `vendors/${vendorId}/${type}`,
  deleteVendor: (vendorId: string) => `vendors/${vendorId}`,
};

// Quarantine
export const urlApiQuarantine = {
  getListQuarantine: 'quarantines',
  createRepairQuarantine: (quarantineId: string) => `quarantines/${quarantineId}/revert`,
  deleteQuarantine: (quarantineId: string) => `quarantines/${quarantineId}`,
  updateQuarantine: (quarantineId: string) => `quarantines/${quarantineId}`,
  createQuarantine: 'quarantines/new',
  getDetailQuarantine: (quarantineId: string) => `quarantines/${quarantineId}`,
};

// Invoice
export const urlApiInvoice = {
  getListInvoice: 'invoices',
  createInvoice: 'invoices/new',
  updateInvoice: (invoiceId: string) => `invoices/${invoiceId}`,
  getDetailInvoice: (invoiceId: string) => `invoices/${invoiceId}`,
  deleteInvoice: (invoiceId: string) => `invoices/${invoiceId}`,
  sendMailInvoice: (invoiceId: string) => `invoices/${invoiceId}/send-mail`,
  changeStatusInvoice: (invoiceId: string) => `invoices/${invoiceId}/change-status`,
};

// Payments
export const urlApiPayment = {
  getList: 'payments',
  create: 'payments/new',
};

// Role
export const urlApiRole = {
  getListRole: 'roles',
  createRole: 'roles/new',
  updateRole: (roleId: string) => `roles/${roleId}`,
  getDetailRole: (roleId: string) => `roles/${roleId}`,
  deleteRole: (roleId: string) => `roles/${roleId}`,
};

// Venue
export const urlApiVenue = {
  getListVenue: 'venues',
  createVenue: 'venues/new',
  editVenue: (venueId: string) => `venues/${venueId}`,
  getDetailVenue: (venueId: string) => `venues/${venueId}/overview`,
  deleteVenue: (venueId: string) => `venues/${venueId}`,
};

// Note
export const urlApiNote = {
  createNote: 'notes/new',
};

// Note
export const urlApiStatistic = {
  getStatisticClientType: 'statistics/client-type',
  getStatisticDashboardOverview: (type: string) => `statistics/dashboard-overview/${type}`,
  getStatisticTodayTask: 'statistics/today-task',
  getStatisticTodaySchedule: 'statistics/today-schedule',
  getStatisticOrderUnpaidDeposit: 'statistics/order-unpaid-deposit',
  getStatisticOrderDepositNotRequired: 'statistics/order-deposit-not-required',
  getStatisticQuoteConverted: 'statistics/quote-converted',
  getStatisticOverbookingItem: 'statistics/overbooking-item',
  getStatisticOutstandingSiteVisit: 'statistics/outstanding-site-visit',
  getStatisticForemanPerformance: 'statistics/foreman-performance',
  getStatisticDailyLoading: 'statistics/daily-loading',
};

// Goal
export const urlApiSettingGoal = {
  getDetailGoal: 'goals',
  createSettingGoal: 'goals/setting',
};

// LinxUp Locations
export const urlApiLinxUp = {
  getListTruckLocation: 'linxup/locations',
};
